<template>
  <div class="body">
    <div class="caption">
      <h1>DogMotics SELF h24</h1>
      <h5>Scopri il costo dei pacchetti di lavaggio per il tuo cane</h5>
    </div>
    <div class="button-box">
      <b-container>
        <b-col>
          <div class="col align-self-center button" variant="primary" size="md" @click.prevent="onClickButton" style="max-width: 44%; padding: 10px;">
            <strong><h1>ENTRA</h1></strong>
          </div>
        </b-col>
      </b-container>
    </div>
  </div>
</template>

<script>
  import { db } from '../firebase/config.js';
  import { mapMutations } from 'vuex';

  export default {
    data() {
      return {
        orgId: '',
        shopName: ''
      }
    },
    //setup() {console.log('setup')},
    //beforeCreate() {console.log('beforeCreate')},
    created() {
      //console.log('created')
      const storeCode = this.$route.query.storeCode ?? 'mi1'
      console.log('storeCode: ', storeCode)
      
      db.collection('stores').doc(storeCode).get()
      .then((doc) => {
        console.log('store:', storeCode, doc.data().shortLocation ?? 'missing data')
        
        if(doc.exists) {
          this.orgId = doc.data().orgId
          this.shopName = doc.data().shortLocation
        } else {
          alert('Codice negozio errato o mancante')
          return
        }
        const userData = {
          orgId: this.orgId,
          shopName: this.shopName,
        }
        this.set_sel_user({...userData})
      })
    },
    //beforeMount() {console.log('beforeMount')},
    methods: {
      onClickButton() {
        event.preventDefault()
        this.$router.push({ name: 'welcome' })
      },
      ...mapMutations({
        set_sel_user: 'SET_SEL_USER',
      })
    }
  };
</script>
<style>
.body {
  width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    position: fixed;
    background-image: url(../assets/home.jpg) !important;
    background-color:#ccc; 
    background-repeat: no-repeat;
    background-size: cover;
    background-position-x: center 
}
.title-box {
  height: 70%;
  width: 80%px;  
}
.button-box {
  height: 25%;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}
.button {
    max-width: 44% important!;
    color: #fff;
    border-radius: 20px;
    background-color: #bad000;
    padding: 10px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }
  .button:hover {
    background-color: #777;
    cursor: pointer;
  }
</style>
/*<style>
  .body-of-home {
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    position: fixed;
    background-image: url(../assets/home.jpg) !important;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-size: cover
  }
  .caption {
    width: 50%;
    height: 60vh;
    color: #fff;
    padding: 100;
    text-align: center;
    margin: 30px auto;
  }
  .button {
    width: 20%;
    height: 70px;
    color: #fff;
    border-radius: 20px;
    background-color: #bad000;
    padding: 10px;
    vertical-align: bottom;
    text-align: center;

    position: relative;
    margin: 30px auto;
  }
  .button:hover {
    background-color: #777;
    cursor: pointer;
  }
</style>*/